import Image from "next/image";
import Link from "next/link";

import cn from "classnames";

import { Chip } from "@/components/chip/chip.component";
import { Text } from "@/components/text/text.component";
import { Chip as PromoChip, NavigationGroup } from "@/sanity.types";
import { urlFor } from "@/sanity/utils";

export const HeaderMegaMenuFeaturedItem = ({
  item,
  className,
  linkClassName,
}: HeaderMegaMenuFeaturedItemProps) => {
  const imageUrl = item.image
    ? urlFor(item.image).width(130).height(130).url()
    : null;
  if (!item.link) return null;

  const chips = item.promotion?.chips;

  return (
    <li className={cn("flex-1", className)}>
      <Link
        href={{
          pathname: item.link.url,
          query: item.link.queryString,
        }}
        className={cn(
          "hover:border-secondary-100 relative flex h-full items-center justify-center gap-4 rounded-2xl border border-white/15 bg-[rgba(0,34,106,0.40)] p-4 text-center transition-all duration-600 hover:bg-[rgba(0,34,106,0.6)]",
          linkClassName,
          {
            "flex-col": !linkClassName,
          },
        )}>
        {chips?.length ? (
          <div
            className="absolute top-4 left-4 z-10 flex flex-row flex-wrap gap-1"
            data-testid="header-mega-menu-featured-item-chips">
            {chips.map((chip: PromoChip, index) => (
              <Chip
                key={chip.label ?? "" + index}
                label={chip.label ?? ""}
                variant="promo"
                chip={chip}
              />
            ))}
          </div>
        ) : null}
        {imageUrl ? (
          <Image
            src={imageUrl}
            alt=""
            width={130}
            height={130}
            aria-hidden="true"
            className="block"
          />
        ) : null}
        <Text variant="body2" className="text-center" component="span">
          {item.label}
        </Text>
      </Link>
    </li>
  );
};

export type HeaderMegaMenuFeaturedItemProps = {
  item: FeaturedItem;
  className?: string;
  linkClassName?: string;
};

type FeaturedItem = NonNullable<
  NonNullable<NavigationGroup["featuredItems"]>[number]
> & {
  promotion?: {
    chips?: PromoChip[] | null;
  } | null;
};
